export default __webpack_public_path__ + "static/media/gallery_00.d8a24f11.jpg";